import { canUseDOM } from '..';

export const getScrollingElem = () =>
  canUseDOM && ((document.scrollingElement || document.documentElement) as HTMLElement);
